import { apiFetch } from '../../../lib/api/client.js';
import type { MinesCashoutResult, MinesLiveState, MinesRevealResult, OpenMinesRequest } from './types.js';

export function getActiveMines(): Promise<MinesLiveState | null> {
  return apiFetch<MinesLiveState | null>('/originals/mines/active');
}

/** A 202 answer is an unconfirmed stake: `status: 'unconfirmed'`, the board opens once it is confirmed. */
export function openMines(body: OpenMinesRequest): Promise<MinesLiveState> {
  return apiFetch<MinesLiveState>('/originals/mines/open', {
    method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body),
  });
}

export function revealMines(roundId: string, tileIndex: number): Promise<MinesRevealResult> {
  return apiFetch<MinesRevealResult>('/originals/mines/reveal', {
    method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ roundId, tileIndex }),
  });
}

export function cashoutMines(roundId: string): Promise<MinesCashoutResult> {
  return apiFetch<MinesCashoutResult>('/originals/mines/cashout', {
    method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ roundId }),
  });
}
